﻿export function initCookieConsent() {
    const COOKIE_KEY = "viwo_cookie_consent_minimal";
    const popup = document.getElementById("cookieConsent");
    if (!popup) return;

    const acceptBtn = popup.querySelector(".cookie-consent-minimal__accept");
    const closeBtn = popup.querySelector(".cookie-consent-minimal__close");

    const hasConsent = () => ["1", "accepted"].includes(localStorage.getItem(COOKIE_KEY));
    const setConsent = (value) => localStorage.setItem(COOKIE_KEY, value);

    if (!hasConsent()) {
        window.setTimeout(() => {
            popup.classList.add("show");
        }, 700);
    }

    const handleAccept = () => {
        setConsent("accepted");
        popup.classList.remove("show");
        window.dispatchEvent(new CustomEvent("acran:analytics-consent"));
    };

    const handleClose = () => {
        setConsent("dismissed");
        popup.classList.remove("show");
    };

    acceptBtn?.addEventListener("click", handleAccept);
    closeBtn?.addEventListener("click", handleClose);
}
